var map = {
	"./EVO.png": 1678,
	"./Path 20295.png": 1679,
	"./ab-img.webp": 1680,
	"./ab-title-cn.webp": 1681,
	"./ab-title-en.webp": 1682,
	"./ag-img.png": 1683,
	"./ag-img.webp": 1684,
	"./ag-title-cn.webp": 1685,
	"./ag-title-en.webp": 1686,
	"./chess-img.webp": 1687,
	"./coin-img.webp": 1688,
	"./content-img.webp": 1689,
	"./dg-img.webp": 1690,
	"./dg-title-cn.webp": 1691,
	"./dg-title-en.webp": 1692,
	"./diamond-img.webp": 1693,
	"./dice-coin.webp": 1694,
	"./ea-img.webp": 1695,
	"./ea-title-cn.webp": 1696,
	"./ea-title-en.webp": 1697,
	"./evo-img.webp": 1698,
	"./evo-title-cn.webp": 1699,
	"./evo-title-en.webp": 1700,
	"./golddice-img.webp": 1701,
	"./gp-img.webp": 1702,
	"./gp-title-cn.webp": 1703,
	"./gp-title-en.webp": 1704,
	"./heart-coin-img.webp": 1705,
	"./lc-bg.webp": 1706,
	"./mg-img.webp": 1707,
	"./mg-title-cn.webp": 1708,
	"./mg-title-en.webp": 1709,
	"./pp-img.webp": 1710,
	"./pp-title-cn.webp": 1711,
	"./pp-title-en.webp": 1712,
	"./pt-img.webp": 1713,
	"./pt-title-cn.webp": 1714,
	"./pt-title-en.webp": 1715,
	"./sa-img.webp": 1716,
	"./sa-title-cn.webp": 1717,
	"./sa-title-en.webp": 1718,
	"./sbo-img.webp": 1719,
	"./sbo-title-cn.webp": 1720,
	"./sbo-title-en.webp": 1721,
	"./spade-img.webp": 1722,
	"./title-cn.webp": 1723,
	"./title-en.webp": 1724,
	"./white-spade-img.webp": 1725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1677;